import Stripe from 'stripe'
import { SubscriptionPlanEnum } from './company'
import { IPrice } from '../data/stripe/prices'

export type StripePaymentStatus =
| 'active'
| 'canceled'
| 'incomplete'
| 'incomplete_expired'
| 'past_due'
| 'paused'
| 'trialing'
| 'unpaid'

export interface IStripeTaxes {
  [key: string]: string[]
}

export interface IStripeSubscriptionObject {
  id: string
  companyId: string
  customer_email: string
  charge: string
}

export interface IStripeReceipt {
  emailList: string[]
  companyId: string
  receiptUrl: string
  orderId: string
}

export interface IUpcomingInvoiceDiscount {
  amount: number
  coupon?: {
    id: string
    percent_off?: number
    amount_off?: number
    duration: string
    duration_in_months?: number
  }
}

export interface IPlanPrices {
  monthly: IPrice
  annual: IPrice
}

export interface IUpcomingInvoicePrices {
  Core: IPlanPrices
  Complete: IPlanPrices
}

export interface IUpcomingInvoiceInformation {
  prorateAmount: number
  nextInvoiceAmount: number
  nextInvoiceDate: string
  isSameInvoiceAmount: boolean
  isTrial: boolean
  forPlan?: SubscriptionPlanEnum
}

export interface IUpcomingInvoiceParams {
  customer: string
  subscription: string
  subscription_items: Stripe.SubscriptionItemUpdateParams[]
  subscription_proration_date?: number
}


export const zeroUpcomingInvoiceInformation: IUpcomingInvoiceInformation = {
  prorateAmount: 0,
  nextInvoiceAmount: 0,
  nextInvoiceDate: '',
  isSameInvoiceAmount: false,
  isTrial: false,
  forPlan: SubscriptionPlanEnum.freemium,
}